export const ANONYMOUS_CART = 'ANONYMOUS_CART';
export function setAnonymousCart(Cart) {
  return {
    type: ANONYMOUS_CART,
    payload: Cart,
  };
}
